import React from "react";
import PropTypes from "prop-types";

/**
 * Icons that can easily be reused in all the project
 */
const PenIcon = ({ size, color, marginRight, ...props }) => (
  <svg
    x="0px"
    y="0px"
    viewBox="0 0 14 14"
    xmlSpace="preserve"
    width={`${size}`}
    height={`${size}`}
    style={{ marginRight }}
    {...props}
  >
    <path
      d="M10.0779 1.50136C10.2368 1.34241 10.4255 1.21632 10.6332 1.1303C10.8409 1.04428 11.0635 1 11.2883 1C11.513 1 11.7356 1.04428 11.9433 1.1303C12.151 1.21632 12.3397 1.34241 12.4986 1.50136C12.6576 1.66031 12.7837 1.84901 12.8697 2.05669C12.9557 2.26436 13 2.48695 13 2.71174C13 2.93653 12.9557 3.15912 12.8697 3.3668C12.7837 3.57447 12.6576 3.76317 12.4986 3.92212L4.32855 12.0922L1 13L1.90779 9.67145L10.0779 1.50136Z"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="rgba(0, 0, 0, 0)"
    />
  </svg>
);

PenIcon.propTypes = {
  /**
   * What background color to use
   */
  color: PropTypes.string,
  /**
   * How large should the icon be?
   */
  size: PropTypes.number,
  /**
   * Margin at the right of the icon
   */
  marginRight: PropTypes.number
};

PenIcon.defaultProps = {
  color: "#ffffff",
  size: 20,
  marginRight: 0
};

export default PenIcon;
